import { render, staticRenderFns } from "./PeopleFunded.vue?vue&type=template&id=7ab7a3fb&"
import script from "./PeopleFunded.vue?vue&type=script&lang=js&"
export * from "./PeopleFunded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports